<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer001">
<p class="OT">Contents</p>
<p class="CON1" id="toc1"><a href="#/Reid_Wisdoms_Feast4#_idTextAnchor001"><em>Acknowledgments</em></a></p>
<p class="CON1" id="toc2"><a href="#/Reid_Wisdoms_Feast5#_idTextAnchor002"><em>Abbreviations</em></a></p>
<p class="CON1" id="toc3"><a href="#/Reid_Wisdoms_Feast6#_idTextAnchor003">Introduction</a></p>
<p class="CON1" id="toc4"><a href="#/Reid_Wisdoms_Feast7#_idTextAnchor174">1. Creation of the World and of Humankind</a></p>
<p class="CON1" id="toc5"><a href="#/Reid_Wisdoms_Feast8#_idTextAnchor337">2. The Entry of Sin into the World and Its Aftermath</a></p>
<p class="CON1" id="toc6"><a href="#/Reid_Wisdoms_Feast9#_idTextAnchor547">3. Parables of Female Godliness</a></p>
<p class="CON1" id="toc7"><a href="#/Reid_Wisdoms_Feast10#_idTextAnchor737">4. Mary: Prophet of a New Creation</a></p>
<p class="CON1" id="toc8"><a href="#/Reid_Wisdoms_Feast11#_idTextAnchor1016">5. Women Healed and Healing</a></p>
<p class="CON1" id="toc9"><a href="#/Reid_Wisdoms_Feast12#_idTextAnchor1154">6. Deacon Phoebe and Other Women Ministers</a></p>
<p class="CON1" id="toc10"><a href="#/Reid_Wisdoms_Feast13#_idTextAnchor1439">7. Mary Magdalene, Junia, and Other Apostles</a></p>
<p class="CON1" id="toc11"><a href="#/Reid_Wisdoms_Feast14#_idTextAnchor1646">8. Pitting Mary against Martha: <br/>Conflicts over Women’s Roles</a></p>
<p class="CON1" id="toc12"><a href="#/Reid_Wisdoms_Feast15#_idTextAnchor1832">9. From Death to New Life</a></p>
<p class="CON1" id="toc13"><a href="#/Reid_Wisdoms_Feast16#_idTextAnchor1986">Conclusion</a></p>
<p class="CON1" id="toc14"><a href="#/Reid_Wisdoms_Feast17#_idTextAnchor1987"><em>Bibliography</em></a></p>
<p class="CON1" id="toc15"><a href="#/Reid_Wisdoms_Feast18#_idTextAnchor1988"><em>Subject and Name Index</em></a></p>
<p class="CON1" id="toc16"><a href="#/Reid_Wisdoms_Feast19#_idTextAnchor1989"><em>Scripture Index</em></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Reid_Wisdoms_Feast-3.vue?24fff4c3